import React from 'react';
import PropTypes from 'prop-types';
import './styles/styles.scss';

const ErrorMessage = (props) => {
  return (
    <div className="error-message">{props.children}</div>
  );
};

ErrorMessage.propTypes = {
  children: PropTypes.node,
};

export default ErrorMessage;
